import { getFeatureAvailability } from './featureAvailability';
import styles from './FeatureGate.module.css';

export default function FeatureGate({ feature, children }) {
  const availability = getFeatureAvailability(feature);
  if (!availability.canOpen) return <section className={styles.unavailable}>
    <span className={styles.badge}>{availability.mode === 'comingSoon' ? 'Coming soon' : 'Unavailable'}</span>
    <h1>{availability.label}</h1>
    <p>{availability.message}</p>
  </section>;

  if (availability.mode === 'enabled') return children;
  return <div className={styles.frame}>
    <aside className={styles.banner} aria-label={`${availability.label} preview information`}>
      <span className={styles.badge}>Preview</span>
      <p>{availability.message}</p>
    </aside>
    <div className={styles.content}>{children}</div>
  </div>;
}